module.exports = __webpack_public_path__ + "static/img/kj1-2.32d1868.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/kj1-2.png
// module id = 918
// module chunks = 0